import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import HomePage from "./pages/HomePage";
import HowItWorksPage from "./pages/HowItWorksPage";
import PricingPage from "./pages/PricingPage";
import WhyPage from "./pages/WhyPage";
import EvolutionPage from "./pages/EvolutionPage";
import WhatToExpectPage from "./pages/WhatToExpectPage";
import MatchExplainedPage from "./pages/MatchExplainedPage";
import ConnectExplainedPage from "./pages/ConnectExplainedPage";
import VerificationPage from "./pages/VerificationPage";
import ActiveCitiesPage from "./pages/ActiveCitiesPage";
import CityWaitlistPage from "./pages/CityWaitlistPage";
import GeneralWaitlistPage from "./pages/GeneralWaitlistPage";
import AdminPage from "./pages/AdminPage";
import AnatomyPage from "./pages/AnatomyPage";
import AboutPage from "./pages/AboutPage";
import ProblemPage from "./pages/ProblemPage";
import CareersPage from "./pages/CareersPage";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/how-it-works" element={<HowItWorksPage />} />
            <Route path="/pricing" element={<PricingPage />} />
            <Route path="/why-apps-feel-broken" element={<WhyPage />} />
            <Route path="/evolution" element={<EvolutionPage />} />
            <Route path="/what-to-expect" element={<WhatToExpectPage />} />
            <Route path="/match" element={<MatchExplainedPage />} />
            <Route path="/connect" element={<ConnectExplainedPage />} />
            <Route path="/verification" element={<VerificationPage />} />
            <Route path="/cities" element={<ActiveCitiesPage />} />
            <Route path="/waitlist/:slug" element={<CityWaitlistPage />} />
            <Route path="/join" element={<GeneralWaitlistPage />} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/anatomy" element={<AnatomyPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/problem" element={<ProblemPage />} />
            <Route path="/careers" element={<CareersPage />} />
          </Routes>
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
